<template>
  <div>
    <div class="wrap_page">
      <div class="header_box flex flex-justify">
        <div class="item">
          <p class="txt">自主研发</p>
          <div class="h2">￥{{ zizhu }}</div>
          <p class="txt2">
            年同比 <span>{{ zizhuRatio }}%</span>
          </p>
        </div>
        <div>
          <p class="txt">委托研发</p>
          <div class="h2">￥{{ weituo }}</div>
          <p class="txt2">
            年同比 <span>{{ weituoRatio }}%</span>
          </p>
        </div>
        <div>
          <p class="txt">合作研发</p>
          <div class="h2">￥{{ hezuo }}</div>
          <p class="txt2">
            年同比 <span>{{ hezuoRatio }}%</span>
          </p>
        </div>
        <div>
          <p class="txt">集中研发</p>
          <div class="h2">￥{{ jizhong }}</div>
          <p class="txt2">
            年同比 <span>{{ jizhongRatio }}%</span>
          </p>
        </div>
      </div>

      <div class="content_box" style="margin-top: 50px">
        <el-form :inline="true" label-position="left" class="flex flex-wrap">
          <div>
            <el-form-item label="时间：">
              <el-date-picker
                v-model="value1"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="项目：">
              <el-select v-model="queryParam.projectType">
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in projectTypes"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </div>
        </el-form>

        <div id="echarts1"></div>
        <div class="text">各类研发费用占比</div>
        <div class="flex" style="width: 100%; height: 300px">
          <div id="echarts2"></div>
          <div class="data">
            <!--            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>
            <p><span>0%</span><span>￥0.00</span></p>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { costByType, manHour, cost } from "./index";
export default {
  data() {
    return {
      queryParam: {},
      value1: [],
      zizhu: 0,
      zizhuRatio: 0,
      weituo: 0,
      weituoRatio: 0,
      hezuo: 0,
      hezuoRatio: 0,
      jizhong: 0,
      jizhongRatio: 0,
      projectTypes: [
        { value: 1, label: "自主研发" },
        { value: 2, label: "委托研发" },
        { value: 3, label: "合作研发" },
        { value: 4, label: "集中研发" },
      ],
    };
  },
  mounted() {
    this.init();
    this.echarts1();
    this.echarts2();
  },
  methods: {
    search() {
      this.echarts1();
      this.echarts2();
    },
    init() {
      costByType().then((res) => {
        if (res.code == "00000") {
          res.data.forEach((item) => {
            if (item.projectType == 1) {
              this.zizhu = item.totalCost;
              this.zizhuRatio = item.ratio;
            }
            if (item.projectType == 2) {
              this.weituo = item.totalCost;
              this.weituoRatio = item.ratio;
            }
            if (item.projectType == 3) {
              this.hezuo = item.totalCost;
              this.hezuoRatio = item.ratio;
            }
            if (item.projectType == 4) {
              this.jizhong = item.totalCost;
              this.jizhongRatio = item.ratio;
            }
          });
        }
      });
    },
    echarts1() {
      this.queryParam.startTime = this.value1[0];
      this.queryParam.endTime = this.value1[1];
      manHour(this.queryParam).then((res) => {
        if (res.code == "00000") {
          // 基于准备好的dom，初始化echarts实例
          let echarts1 = this.$echarts.init(
            document.getElementById("echarts1")
          );
          // 绘制图表
          echarts1.setOption({
            title: { text: "" },
            tooltip: {},
            xAxis: {
              data: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
            },
            yAxis: {
              type: "value",
            },
            legend: {
              // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
              orient: "horizontal",
              // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
              x: "right",
              // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
              y: "top",
              data: ["研发工时"],
            },
            color: "#4988df",
            series: [
              {
                name: "研发工时",
                type: "line",
                data: res.data,
              },
            ],
          });

          setTimeout(function () {
            window.onresize = function () {
              echarts1.resize();
            };
          }, 100);
        }
      });
    },

    echarts2() {
      this.queryParam.startTime = this.value1[0];
      this.queryParam.endTime = this.value1[1];
      cost(this.queryParam).then((res) => {
        let data = [];
        res.data.forEach((item) => {
          data.push({ value: item.value, name: item.name });
        });
        let echarts2 = this.$echarts.init(document.getElementById("echarts2"));
        echarts2.setOption({
          title: {
            //标题组件
            text: "研发费用占比",
            x: "15%", //标题的位置 默认是left，其余还有center、right属性
            top: "35%",
            textStyle: {
              color: "#436EEE",
              fontSize: 17,
            },
          },
          tooltip: {
            //提示框组件
            trigger: "item", //触发类型(饼状图片就是用这个)
            formatter: "{a} <br/>{b} : {c} ({d}%)", //提示框浮层内容格式器
          },
          color: [
            "#48cda6",
            "#fd87fb",
            "#11abff",
            "#FF6F6C",
            "#F5C500",
            "#567191",
            "#FFA761",
            "#42A2A9",
          ], //手动设置每个图例的颜色
          legend: {
            //图例组件
            //right:100,  //图例组件离右边的距离
            icon: "circle",
            orient: "horizontal", //布局  纵向布局 图例标记居文字的左边 vertical则反之
            width: 40, //图行例组件的宽度,默认自适应
            x: "45%", //图例显示在右边
            y: "center", //图例在垂直方向上面显示居中
            itemWidth: 10, //图例标记的图形宽度
            itemHeight: 10, //图例标记的图形高度
            textStyle: {
              //图例文字的样式
              color: "#333", //文字颜色
              fontSize: 14, //文字大小
              lineHeight: 24, //行高
            },
          },
          series: [
            //系列列表
            {
              name: "", //系列名称
              type: "pie", //类型 pie表示饼图
              center: ["20%", "50%"], //设置饼的原心坐标 不设置就会默认在中心的位置
              radius: ["50%", "70%"], //饼图的半径,第一项是内半径,第二项是外半径,内半径为0就是真的饼,不是环形
              itemStyle: {
                //图形样式
                normal: {
                  //normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式，比如在鼠标悬浮或者图例联动高亮时。
                  label: {
                    //饼图图形上的文本标签
                    show: true, //平常不显示
                  },
                  labelLine: {
                    //标签的视觉引导线样式
                    show: true, //平常不显示
                  },
                },
                emphasis: {
                  //normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式，比如在鼠标悬浮或者图例联动高亮时。
                  label: {
                    //饼图图形上的文本标签
                    show: false,
                    position: "center",
                    textStyle: {
                      fontSize: "12",
                      fontWeight: "bold",
                    },
                  },
                },
              },
              data: data,
            },
          ],
        });
        setTimeout(function () {
          window.onresize = function () {
            echarts2.resize();
          };
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
.header_box > div {
  width: 22%;
  border-bottom: 1px solid #dbdbdb;
}
.header_box > div .txt {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}
.header_box > div .txt2 {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}
.header_box > div .h2 {
  font-size: 30px;
  color: rgba(0, 0, 0, 0.85);
}
#echarts1 {
  width: 100%;
  height: 300px;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
#echarts2 {
  width: 80%;
  height: 300px;
}
.data {
  width: 20%;
  padding: 0 20px;
}
.data p {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 22px;
}
</style>
